export default __webpack_public_path__ + "static/media/dash_1.deadf2be.svg";